import * as React from "react";
import {createElement as h} from "react";

import {AnyAction}             from "../../react/any-action";
import {cs}                    from "../../react/chain-services";
import {GlobalEvent}           from "../../react/global-event";
import {Static2}               from "../../react/static-2";
import {UseState}              from "../../react/use-state";
import {Types}                 from "../../types";
import {isChildNode}           from "../../utils/dom";
import {OnGlobalKeyDownEscape} from "../browser/global-key-down-escape";

import {ExpandPosition} from "./expand-position";

export const Dropdown = ({
    renderExpand,
    renderToggle,
    minExpandHeight=200,
    minExpandWidth=undefined,
    expandDistance=0,
    forcedExpandLeft=false,
    forcedExpandBottom=false,
    scrollCloses=true,
    mobilePinToTop=false,
    onClose=undefined,
}:{
    expandDistance     ?: number,
    forcedExpandLeft   ?: boolean,
    forcedExpandBottom ?: boolean,
    minExpandHeight    ?: number,
    minExpandWidth     ?: number,
    renderExpand        : (props:Types.Common.UiComponents.Dropdown.ExpandProps) => JSX.Element,
    renderToggle        : (props:Types.Common.UiComponents.Dropdown.ToggleProps) => JSX.Element,
    scrollCloses       ?: boolean,
    mobilePinToTop     ?: boolean,
    onClose            ?: () => void,
}) => cs(
    ["expanded", (_, next) => UseState({
        initValue: false,
        next
    })],
    ["toggleDomRef", (_, next) => Static2({next})],
    ["expandDomRef", (_, next) => Static2({next})],
    ({expanded, toggleDomRef, expandDomRef}) => <>
        {renderToggle({
            domRef: toggleDomRef.set,
            showExpand: (show=true) => {
                show = show === undefined ? !expanded.value : show;
                if (show !== expanded.value) {
                    expanded.onChange(show);
                    // setTimeout(() => {
                    // }, 0);
                }
            },
            showingExpand: expanded.value,
        })}
        {expanded.value && cs(
            ["expandPosition", (_, next) => ExpandPosition({
                dom: toggleDomRef.get(),
                forcedLeft: forcedExpandLeft,
                forcedBottom: forcedExpandBottom,
                minHeight: minExpandHeight + (expandDistance??0),
                minWidth: minExpandWidth,
                next,
            })],
            ({expandPosition}) => <>
                {OnGlobalKeyDownEscape({
                    action: () => {
                        if (onClose) {
                            onClose();
                        }
                        expanded.onChange(false)
                    },
                })}

                {renderExpand({
                    close: () => {
                        if (onClose) {
                            onClose();
                        }
                        expanded.onChange(false)
                    },
                    width: mobilePinToTop ? "100%" : expandPosition.width,
                    position: {
                        ...expandPosition.top != null ? {
                            top: expandPosition.top + (expandDistance??0),
                        } : {
                            bottom: expandPosition.bottom + (expandDistance??0),
                        },
                        ...expandPosition.left != null ? {
                            left: expandPosition.left,
                        } : {
                            right: expandPosition.right,
                        },
                    },
                    domRef: expandDomRef.set,
                })}

                {scrollCloses && GlobalEvent({
                    eventName: "scroll",
                    fn: () => {
                        if (onClose) {
                            onClose();
                        }
                        expanded.onChange(false)
                    },
                })}

                {h(AnyAction, {
                    capture: true,
                    action: (e:React.UIEvent) => {
                        if (!isChildNode(e.target, toggleDomRef.get()) && !isChildNode(e.target, expandDomRef.get())) {
                            if (onClose) {
                                onClose();
                            }
                            expanded.onChange(false)
                        }
                    },
                })}
            </>,
        )}
    </>
);

